import styles from "./InsightsLayout.module.css";

export const StatsRow = ({ children }) => <div className={styles.statsRow}>{children}</div>;

export const ChartsGrid = ({ children }) => <div className={styles.chartsGrid}>{children}</div>;

export const InsightsPanel = ({ children }) => <div className={styles.panel}>{children}</div>;
